import React from 'react';

const ShieldIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M32 4L56 16V32C56 44.1503 45.2548 54 32 54C18.7452 54 8 44.1503 8 32V16L32 4Z" stroke="#3BAAB0" strokeWidth="3" fill="none"/>
    <path d="M24 32L30 38L40 26" stroke="#3BAAB0" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ShieldIcon;
